
import { FEDERATION_URL as uri } from 'Graph';
import { CoreGraphLinkProvider } from '@neustar/core-ui';

export const FederationProvider: CoreGraphProviderStaticClassType = CoreGraphLinkProvider({ uri });

export const FederationPollingProvider: CoreGraphProviderStaticClassType = CoreGraphLinkProvider({ uri, silent: true });
